export const HERO = {
  title: "I'm",
  subtitle: "Hello, I'm ",
  name: "Noyon Islam",
  typeWriter: ["Full Stack Developer", "Web Developer", "Mobile App Developer"],
  bgImage: "/Asset/bg.png",
  button: {
    text: "My Resume",
    url: "/Resume .pdf",
  },
};
